import { FiHash } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const NumberField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    type="number"
    placeholder={field.placeholder || field.label}
    icon={FiHash}
    disabled={disabled}
    required={field.is_required}
    inputMode="numeric"
  />
);

export default NumberField;
